{
  "title": "Pipelines",
  "newPipeline": "New Pipeline",
  "documentation": "Documentation",
  "allPipelines": "All Pipelines",
  "addsource": "Add a new source",
  "addsink": "Add a new destination",
  "addtransform": "Add a new processor",
  "updatesourcenode": "{{nodeType}} source",
  "updatesinknode": "{{nodeType}} destination",
  "updatetransformnode": "{{nodeType}} processor",
  "sources": "Sources",
  "recommendedSources": "Recommended Sources",
  "recommendedSourcesDescription": "These sources live at the account level. Every pipeline that adds one reads from the same ingest stream.",
  "transforms": "Processors",
  "processors": "Processors",
  "sinks": "Destinations",
  "source": "source",
  "transform": "processor",
  "sink": "destination",
  "destinations": "Destinations",
  "addNodeDisabledTooltip": "You have exceeded the allotted quota of {{ label }} per pipeline allowed for this plan.",
  "aiAddNodes": {
    "button": "Add with AI",
    "tooltip": "Add nodes to your pipeline with AI. Just describe what you want and Mezmo Assistant will build it."
  },
  "noResults": "No results found",
  "noPipelinesCreated": "No pipelines created",
  "noNodesFilter": "No <span class=\"text-lowercase\">{{ label }}</span> found that contain your search query.  Please modify and try again.",
  "selectBack": "Select a different {{label}}",
  "moreInfo": "More info",
  "exitSimulation": "Exit Simulation",
  "pausePipeline": "Pause Pipeline",
  "unpausePipeline": "Restart Pipeline",
  "paused": "Paused",
  "deployed": "Deployed",
  "suspended": "Suspended",
  "suspendedTooltip": "Monthly quota reached",
  "pauseWarning": "This pipeline is currently paused and is not processing data.",
  "accountSuspendedWarning": "You have exceeded your allotted quota for the month.",
  "conflictingChangeError": "This change failed to save due to a conflict with another users session.  Click ok to update the pipeline configuration and try again.",
  "existingSources": "Shared Sources",
  "newSources": "New Sources",
  "confirmModalClose": "Closing this drawer will discard your changes. Do you want to continue?",
  "currentlyViewOnly": "This processor configuration is currently view only while in monitor mode.",
  "modifyInEditMode": "Modify in edit mode",
  "nodeDoesNotExistInEditMode": "This node no longer exists in the draft pipeline.",
  "edgeInstanceHeartbeatFail": "The heartbeat update for the '{{ name }}' instance failed to check-in within the allotted time period",
  "addEditNodeResults": "No nodes found. Please refine your search",
  "noAccessKeys": "No access keys",
  "noAccessKeysDescription": "No access keys have been provisioned for this source.",
  "events": "{{count}} event",
  "events_plural": "{{count}} events",
  "parsing": "Parsing",
  "keyManagement": "Key Management",
  "configuration": "Configuration",
  "alertsList": "Alerts",
  "createEdit": {
    "deploymentOptions": "Deployment Options",
    "deploymentOptionsDescription": "Deploy this pipeline in our SaaS cloud environment or deploy it your environment with Edge",
    "saas": "SaaS",
    "edge": "Edge",
    "buildWithAi": {
      "title": "Build with AI",
      "description": "Describe the pipeline you want in plain language and let Mezmo Assistant build it for you by adding sources, processors, and destinations automatically.",
      "button": "Build with AI",
      "defaultName": "New AI Pipeline"
    },
    "installAgent": "Install Agent",
    "goToPipeline": "Go to pipeline",
    "goToProfiler": "Go to Profile",
    "exportManifest": {
      "title": "Export Pipeline",
      "descriptionBefore": "Export the",
      "descriptionLink": "current draft version",
      "descriptionAfter": "of this pipeline's manifest as JSON or YAML. Exports do not include responsive pipeline configuration, pipeline alerts and node alerts.",
      "json": "Export as JSON",
      "yaml": "Export as YAML",
      "error": "Unable to export this pipeline."
    }
  },
  "import": {
    "importPipeline": "Import Pipeline",
    "title": "Import Pipeline",
    "back": "Back to create pipeline",
    "upload": {
      "title": "Upload a pipeline manifest",
      "description": "Drag and drop a pipeline manifest file, or browse to select one. JSON and YAML files are supported.",
      "dropHere": "Drop your file here",
      "dropPrompt": "Drag and drop your manifest file here, or",
      "browse": "Import file",
      "remove": "Remove",
      "invalidType": "Please select a JSON or YAML file.",
      "onlyOneFile": "You can only upload one file at a time.",
      "readError": "Unable to read the selected file.",
      "prepareError": "We couldn't process this manifest. Please check the file and try again.",
      "next": "Continue"
    },
    "secrets": {
      "title": "Provide required secrets",
      "description": "This pipeline references secrets that must be supplied before it can be imported.",
      "required": "This field is required.",
      "none": "This manifest doesn't require any secrets.",
      "back": "Back",
      "submit": "Import Pipeline",
      "importError": "We couldn't import this pipeline. Please try again."
    }
  },
  "modals": {
    "configurePipeline": "Configure Pipeline",
    "createNewPipeline": "Create a new Pipeline",
    "deletePipeline": "Delete Pipeline",
    "deletePipelineWarning": "Stop new data from flowing into the pipeline and delete all nodes.",
    "pipelineTitle": "Pipeline name",
    "durableQueue": "Durable Queue",
    "deleteMessage": "This will delete the <b><em>{{ title }}</em></b> pipeline and all of this pipelines's source, processor and destination nodes.  All inflight data will continue to be processed but any new data will be dropped.",
    "confirmMessage": "Type the name of this pipeline to confirm",
    "copyToml": "Copy TOML",
    "copiedToml": "Copied!",
    "deployPipeline": "Deploy pipeline",
    "publishProcessorGroup": "Publish processor group",
    "deploy": "Deploy",
    "publish": "Publish",
    "deployAndRestart": "Deploy and restart",
    "deployMessage": "Are you sure you want to deploy <b><em>{{ title }}</em></b> pipeline?",
    "publishProcessorGroupMessage": "Are you sure you want to publish <b><em>{{ title }}</em></b> processor group?",
    "unprocessableEntityOutputDeployMessage": "One or more of your node's outputs are not connected to another node. You can continue publishing this pipeline but all data will be dropped at these unconnected nodes.",
    "unprocessableEntityInputDeployMessage": "One or more of your node's input are not connected to another node. You can continue publishing this pipeline but nodes with no input won't receive any data.",
    "unprocessableEntitySourceNoKeys": "You are attempting to publish a pipeline that contains a source that doesn't have any access keys provisioned.  You may still publish this pipeline but a source without access keys will not be able to pass data through this pipeline.",
    "unableToDeployPipelinePaused": "This pipeline is currently paused.  Continuing to deploy will restart the current pipeline.",
    "failedToDeployUnknownError": "The pipeline failed to publish due to an unknown error. Please try again or contact <a href=\"mailto:support@mezmo.com\">support@mezmo.com</a>",
    "understand": "I understand",
    "unprocessableEntityTitle": "Error",
    "disabledNodeType": "Disabled. This node type is in currently used in:",
    "oneNodeTypePerPipeline": "Only allowed one per pipeline",
    "sharedSourceAlreadyAdded": "Only one of the these nodes is allowed per pipeline because it reads a shared account-wide stream.",
    "duplicateMezmoKey": "The key you entered is already in use as a source in this pipeline.",
    "laSourceLoop": "To use this source, you will need to change your Log Analysis destination to send to a different account",
    "invalidIngestionKey": "Invalid ingestion key.",
    "processingStatusEnableTitle": "Restart pipeline",
    "processingStatusEnable": "Are you sure you want to restart this pipeline? Once restarted the pipeline will begin to process data.",
    "processingStatusDisableTitle": "Pause pipeline",
    "processingStatusDisable": "Pausing a pipeline will stop any new data from entering the pipeline and any inflight data is not guaranteed to make it to the destination.",
    "processingStatusConfirm": "Would you like to continue?",
    "revertMessage": "<p>Reverting to an older version of this pipeline will discard all current draft changes. Your existing draft will be replaced by the reverted version for you to deploy.</p><p>Are you okay with discarding your current draft changes?</p>",
    "resetProfile": "Reset Profile",
    "resetProfileMessage1": "Resetting this shared source's profile will remove all current profile and classification data and rerun the analysis.",
    "resetProfileMessage2": "Are you sure you want to continue?",
    "configureNodeAlert": "Configure Alert",
    "conflictingProcessorGroup": "Cannot add the same processor group more than once in a pipeline.",
    "conflictingProcessorGroupDeploy": "Cannot deploy a pipeline that contains the same Processor Group more than once.  The Processor Group(s) <strong>{{ names }}</strong> are used more than once in this pipeline, please remove the duplicate processor groups and try again.",
    "emptyProcessorGroup": "Cannot deploy a processor group with out any nodes connected to the input node."
  },
  "createLocalPipeline": "Run this pipeline configuration on your local on-premises infrastructure.",
  "local": "Edge",
  "draft": "Draft",
  "saas": "Cloud",
  "draftMessage": "Draft indicates that this pipeline configuration has been never been published.",
  "modified": "Modified",
  "modifiedMessage": "Modified indicates that this pipeline configuration has been updated from what is currently processing your data and has not been published.",
  "published": "Published",
  "publishedMessage": "Pipeline was deployed successfully {{date}}",
  "publishingMessage": "Deploying pipeline",
  "testPipeline": "Test pipeline",
  "editPipeline": "Edit Pipeline",
  "configurePipeline": "Configure pipeline",
  "deletePipeline": "Delete pipeline",
  "deployPipeline": "Deploy pipeline",
  "publishProcessorGroup": "Publish processor group",
  "deployDisabledTooltip": "You have exceeded the allotted quota of deployed pipelines allowed for this plan.",
  "selectANode": "Select a node",
  "apiKey": "API key",
  "apiKeyDescription": "Send data to this source by adding `s_{{apikey}}` in the request `Authorization` header",
  "formTitle": "Title",
  "formTitleHelpDescription": "User provided title for this node",
  "formDesc": "Description",
  "formDescHelpDescription": "User provided description for this node",
  "createPipeline": "Create Pipeline",
  "insertNode": "Insert processor",
  "deleteConnection": "Delete connection",
  "tapConnection": "Insert data tap",
  "backToMonitorMode": "Monitor deployed pipeline",
  "dashboard": {
    "dashboard": "Dashboard",
    "title": "Pipeline Dashboard",
    "systemOverview": "System Overview",
    "overviewDescription": "Usage across all pipelines — what's coming in, what's going out, and where it's going.",
    "byBytes": "By bytes",
    "volumeWidgetTitle": "Ingestion/Egress by Volume",
    "aggregatedEgressWidgetTitle": "Aggregated Egress",
    "totalEgress": "Total Egress",
    "totalEgressExternal": "Total Egress",
    "totalEgressInternal": "Total Internal",
    "totalIngress": "Total Ingress",
    "healthStatus": "Health Status",
    "name": "Name",
    "status": "Status",
    "account": "Account",
    "ingress": "Ingress",
    "egress": "Egress",
    "egress_internal": "Egress Internal",
    "sourcesTop": "Top {{count}} sources",
    "destinationsTop": "Top {{count}} destinations",
    "noResults": "No Results",
    "noResultsTable": "No pipelines exist or are active during this time period",
    "error": "Unable to fetch data at this time",
    "nodeHasBeenDeleted": "This node has been deleted",
    "aggregatedType": "Aggregated {{type}}",
    "totalType": "Total {{type}}",
    "loading": "Loading",
    "overviewNoResults": "No {{type}} existed during the selected time period.",
    "localDeployOverview": "Edge Deployment Overview",
    "localDeployDescription": "Usage for pipelines running on your own infrastructure.",
    "edgeName": "Edge Name",
    "deploymentGroup": "Deployment Group",
    "deploymentGroup_plural": "Deployment Groups",
    "allDeploymentGroups": "All deployment groups",
    "deployedInstances": "Deployed Instance",
    "deployedInstances_plural": "Deployed Instances",
    "instancesDown": "Instance Down",
    "instancesDown_plural": "Instances Down",
    "deployedPipelines": "Deployed Pipeline",
    "deployedPipelines_plural": "Deployed Pipelines",
    "allInstances": "All Instances",
    "noResultsLocalDeployTable": "No edge instances exist or are active during this time period",
    "eyebrow": "Pipelines",
    "sourcesDescription": "Ingress by source across all pipelines.",
    "destinationsDescription": "Egress by destination across all pipelines, including internal routing.",
    "internal": "Internal",
    "volumeChartTitle": "Ingestion & egress by volume",
    "volumeChartNote": "Bytes per {{bucket}} · {{range}}",
    "volumeChartZoomHint": "drag across the chart to zoom",
    "resetZoom": "Reset zoom",
    "bucket": {
      "minutes": "{{count}} min",
      "hour": "hour",
      "day": "day"
    },
    "pipelinesTile": "Pipelines",
    "runningCount": "{{count}} running",
    "pausedCount": "{{count}} paused",
    "aggregatedEgressNote": "Top {{count}} destinations by volume, including internal routing",
    "totalOut": "total out",
    "topComponents": "Top components",
    "topComponentsNote": "Top {{count}} by volume · {{range}}",
    "allSources": "All sources",
    "allDestinations": "All destinations",
    "allPipelinesNote": "{{count}} pipeline · click a volume column to sort",
    "allPipelinesNote_plural": "{{count}} pipelines · click a volume column to sort",
    "componentsAcross": "{{count}} {{type}} across {{pipelines}} pipeline",
    "componentsAcross_plural": "{{count}} {{type}} across {{pipelines}} pipelines",
    "shareOfTotal": "{{percent}} of total",
    "pipeline": "Pipeline",
    "volume": "Volume",
    "trend": "Trend",
    "allReporting": "All reporting",
    "deletedCount": "{{count}} deleted",
    "externalInternal": "{{external}} external · {{internal}} internal",
    "routedInternally": "{{bytes}} routed internally",
    "throughput": "Throughput",
    "live": "Live",
    "acrossSources": "across {{count}} source",
    "acrossSources_plural": "across {{count}} sources",
    "noEventsFlowing": "no events flowing",
    "running": "Running",
    "pipelineGraph": "Pipeline graph",
    "pipelineGraphNote": "Live throughput per component · click a node to inspect it",
    "versionDeployed": "{{version}} deployed",
    "deployedAgo": "{{version}} deployed {{ago}}",
    "sourceCount": "{{count}} source",
    "sourceCount_plural": "{{count}} sources",
    "processorCount": "{{count}} processor",
    "processorCount_plural": "{{count}} processors",
    "destinationCount": "{{count}} destination",
    "destinationCount_plural": "{{count}} destinations",
    "noEdgeTitle": "No edge pipelines yet",
    "noEdgeText": "Edge pipelines run inside your own infrastructure. Once one is deployed, its usage will show up here alongside your cloud pipelines.",
    "edgeGuide": "Read the edge setup guide",
    "perNodeEmpty": "No {{title}} are available",
    "statusLabel": {
      "healthy": "Healthy",
      "warning": "Warning",
      "error": "Error",
      "paused": "Paused",
      "notDeployed": "Not deployed",
      "suspended": "Suspended"
    },
    "chartType": {
      "line": "Line chart",
      "bar": "Bar chart"
    },
    "version": "Version",
    "other": "Other",
    "deleted": "deleted",
    "hangTight": "Hang tight, data is coming.",
    "expandCharts": "Show a chart per node",
    "collapseCharts": "Back to the pipeline graph",
    "deploying": "Deploying",
    "draftCount": "{{count}} draft",
    "draftCount_plural": "{{count}} drafts",
    "vsPrevious": "vs previous {{span}}",
    "previousPeriod": "period"
  },
  "rulesEngine": {
    "outputLabel": "Output Label",
    "outputLabelDescription": "A human-readable name for the overall expression",
    "additionalRoute": "Add route",
    "if": "IF",
    "and": "AND",
    "or": "OR",
    "addExpression": "Add Expression",
    "addNestedGroup": "Add Nested Group",
    "removeNestedGroup": "Remove Nested Group",
    "addGroup": "Add Group",
    "field": "Field",
    "operator": "Operator",
    "value": "Value",
    "removeExpression": "Remove Expression",
    "removeRoute": "Remove Output",
    "ifStatement": "Resulting conditional statement",
    "addCondition": "Add Condition",
    "removeCondition": "Remove Condition"
  },
  "filterProcessor": {
    "action": {
      "title": "Action",
      "description": "How to handle events matching this criteria",
      "allow": "Allow events matching this criteria",
      "drop": "Drop events matching this criteria"
    }
  },
  "tap": {
    "title": "Pipeline Tap",
    "description": "Intercept log events at the {{title}} {{swimlane}} in the pipeline",
    "logEvents": "Set number of log events",
    "clear": "Clear",
    "startTap": "Start Tap",
    "pauseTap": "Pause Tap",
    "requestNumber": "Requested number of logs event (Max. {{max}})",
    "noLogs": "Tap and sample Pipeline data",
    "noLogsMessage": "to start a pipeline tap",
    "noLogsMessage2": "A Pipeline Tap shows the data that is flowing through a Pipeline component like a Source or Processor. You can also save a data sample to use in testing or simulations of your Pipelines before you deploy them. Our documentation topics <a href=\"https://docs.mezmo.com/telemetry-pipelines/view-pipeline-data\" target=\"_blank\">View and Sample Pipeline Data</a> and <a href=\"https://docs.mezmo.com/telemetry-pipelines/simulate-pipeline-data-flows\" target=\"_blank\">Test Pipeline Data Flows</a> contain more information",
    "copyDownload": "Copy/Download",
    "copyAsJson": "Copy as JSON",
    "copyAsNdJson": "Copy as NDJSON",
    "copyAsText": "Copy as Text",
    "downloadAsText": "Download as Text",
    "downloadAsJson": "Download as JSON",
    "downloadAsNdJson": "Download as NDJSON",
    "copy": "Copy",
    "filter": "Apply Filter",
    "reset": "Reset",
    "saveSample": "Save sample",
    "saveAsSample": "Save as sample",
    "sampleSizeWarning": "Sample size cannot be larger than {{size}} events",
    "errorsMessage": "Unable to fetch this node tap data.  Please try again later.",
    "play": "play",
    "pausedTitle": "Pipeline Paused",
    "pausedDescription": "The pipeline is currently paused and not processing data. <br> <br> Our document topics <a href=\"https://docs.mezmo.com/telemetry-pipelines/view-pipeline-data\" target=\"_blank\">Tap a pipeline</a> contains more information.",
    "sampleSaved": "Sample saved successfully",
    "startAnotherTap": "Start another tap",
    "startAnotherTap2": "or begin a pipeline simulation using this sample",
    "startSimulation": "Start pipeline simulation",
    "includedEvents_plural": "Included {{count}} events",
    "includedEvents": "Included {{count}} event",
    "tapPanelHelp": "Nodes that have been deployed can be tapped to view the data flow.  A sources tapped data can be saved as a sample for Simulation<br><a href=\"https://docs.mezmo.com/telemetry-pipelines/view-pipeline-data\" target=\"_blank\">View and Sample Pipeline Data</a>",
    "simulationPanelHelp": "Click on a highlighted node to view the nodes ingress and egress data. <a href=\"https://docs.mezmo.com/telemetry-pipelines/simulate-pipeline-data-flows\" target=\"_blank\">Test Pipeline Data Flows</a> "
  },
  "formbuilder": {
    "dropzonePrompt": "Drop file here or click to upload",
    "dropzonePromptHover": "Drop file here",
    "fileUploadSuccess": "File Uploaded",
    "fileUploadSuccessMessage": "To replace, drop file here or click to upload a new file",
    "fileUploadTooLarge": "File size is too large.",
    "generateNewKey": "Generate new ingestion key",
    "mezmoIngestionKeyTitle": "Mezmo Ingestion key",
    "mezmoIngestionKeyLabel": "Manage Mezmo ingestion key",
    "mezmoIngestionKeyManage": "Manage Mezmo Ingestion Keys"
  },
  "accessKeyManagement": {
    "label": "Label",
    "created": "Created",
    "action": "Action",
    "revoke": "Revoke",
    "newKeysMessage": "Make sure you copy your new access key. You won't be able to see this key again.",
    "createNewKey": "Create new key",
    "noKeys": "No keys have been created yet.",
    "modalTitle": "Create Access Key",
    "title": "Title",
    "type": "Type",
    "autoGenerated": "Auto Generated",
    "userDefined": "User Defined",
    "key": "User defined key",
    "add": "Create",
    "unableToRemoveError": "Unable to remove the access key at this time",
    "unableToCreateError": "Unable to create the access key at this time",
    "instructionsGatewayRoutes": "Send data to this pipeline via a <code>POST</code> request to <code data-copy>https://{{ pipelineIngestionHost }}/v1/{{ consumerId }}</code> with <code data-copy>Authorization</code> header and the access key.",
    "datadogInstructionsGatewayRoutes": "Configuration (via command line or yaml deployment):<br />- If sending logs to Mezmo, override <code data-copy>DD_LOGS_CONFIG_LOGS_DD_URL</code> with <code data-copy>{{ consumerId }}.v1.{{ pipelineIngestionHost }}:443</code><br />- If sending metrics to Mezmo, override <code data-copy>DD_DD_URL</code> with <code data-copy>https://{{ pipelineIngestionHost }}/v1/{{ consumerId }}</code><br />- *Note: APM data is not supported. <code data-copy>DD_APM_DD_URL</code> should not be configured for Mezmo."
  },
  "auditEvents": {
    "auditEvents": "Audit Events",
    "title": "Pipeline Audit Events",
    "description": "View Pipeline audit events for this account.",
    "date": "Date",
    "user": "User",
    "event": "Event",
    "kind": "Type",
    "subject": "Subject",
    "selectPipeline": "Pipelines",
    "selectTransformGroup": "Processor Groups",
    "allPipelines": "All pipelines",
    "allTransformGroups": "All Processor Groups",
    "pipelineName": "Pipeline Name",
    "transformGroup": "Processor Group",
    "dateRange": "Date Range"
  },
  "sampleManagement": {
    "sample": "Sample",
    "metadata": "Metadata",
    "title": "Pipeline Simulation",
    "description": "Choose a sample to run a simulation starting from this source.",
    "addSample": "Create new sample",
    "runSimulation": "Run simulation",
    "deleteSample": "Delete sample",
    "noResults": "Select or create a sample",
    "howTo": "To test your Pipeline data flows, start by selecting an existing data sample, or create a new one. <br /> You can find more information in the topics <a href=\"https://docs.mezmo.com/telemetry-pipelines/view-pipeline-data\" target=\"_blank\">View and Sample Pipeline Data</a> and <a href=\"https://docs.mezmo.com/telemetry-pipelines/simulate-pipeline-data-flows\" target=\"_blank\">Test Pipeline Data Flows</a> in our documentation. ",
    "newSampleBox": "Add event data to use when simulating your Pipeline. <a href=\"https://docs.mezmo.com/telemetry-pipelines/simulate-pipeline-data-flows\" target=\"_blank\">Pipeline Simulation documentation</a>",
    "name": "Sample name",
    "saveSampleEvent": "Save sample event",
    "addSampleEvent": "Add event to sample",
    "removeSampleEvent": "Remove event",
    "resultingSample": "Resulting sample",
    "noSampleEvents": "Paste multiple samples directly as the data type or upload a file. ",
    "sampleManagementTitle": "Pipeline samples for use in simulation and testing",
    "noNodeSamples": "This source does not have samples saved.",
    "noSources": "There are currently no sources configured in this pipeline.",
    "addMetadata": "Add metadata to the event.",
    "invalidMetadata": "Metadata must be valid JSON",
    "clickToView": "Click View Sample to view",
    "viewSample": "View sample",
    "listPanelDescription": "Choose a sample or create a new one to run a pipeline data flow simulation"
  },
  "simulation": {
    "events": "events",
    "noNodeSelectedHeader": "View Source or Processor node data",
    "noNodeSelectedMessage": "Click on a source or processor node to view the sample data input and output for that node. <a href=\"https://docs.mezmo.com/telemetry-pipelines/simulate-pipeline-data-flows\" target=\"_blank\">Test Pipeline Data Flows</a>",
    "problem": "Something has gone wrong. Try running this simulation again.",
    "alertsConfigured": "{{count}} Alert configured",
    "alertsConfigured_plural": "{{count}} Alerts configured",
    "alertsTriggered": "Triggered {{count}} times",
    "alertsTriggered_plural": "Triggered {{count}} times",
    "showAlerts": "Show Alerts",
    "showDiff": "Show Diff"
  },
  "grok": {
    "patternsError": "Unable to retrieve the list of predefined grok patterns.",
    "instructions": "Add your Grok expression below using our predefined Grok patterns. Grok patterns begin with `%{` and will display an autocomplete list of Mezmo's predefined patterns. The following literals are allowed between expressions: `\\s` `,` `;` `:` `-`. Use `%{DATA}` and `%{GREEDYDATA}` to separate desired parsed data."
  },
  "regex": {
    "instructions": "Parse the specified field with a regex pattern.  All regex patterns must contain named capture groups."
  },
  "patternValidator": {
    "validate": "Validate",
    "testTitle": "Test {{type}} pattern",
    "examples": "Add test data and click validate to test the {{type}} pattern. This data is not stored.",
    "results": "Results",
    "noMatches": "The pattern does not match any of the text data."
  },
  "mezmoGate": {
    "learnMore": "Learn more",
    "details": "Using Mezmo Log Analysis as a destination will create a Log analysis account that does not cost you anything. At the end of your Mezmo Trial, this account will convert to a free account.",
    "enable": "Enable Mezmo Log Analysis",
    "skip": "Already have an account",
    "tour": {
      "title": "Mezmo Log Analysis",
      "confirm": "Got it!",
      "first": {
        "title": "Welcome To Log Analysis",
        "description": "You have successfully turned on Mezmo Log Analysis as a pipeline destination."
      },
      "second": {
        "title": "Whole new set of features",
        "description": "The navigation bar has expanded to show more icons. When you’re done configuring your pipeline, check out the Log Analysis features!"
      },
      "third": {
        "title": "Expanded Settings",
        "description": "Go to the settings page to further configure your organization and settings."
      }
    }
  },
  "alerts": {
    "title": "Pipeline Alerts",
    "description": "View historical pipeline errors for this account.",
    "type": "Type",
    "date": "Timestamp",
    "level": "Error Level",
    "swimlane": "Type",
    "node": "Node",
    "kind": "Type",
    "subject": "Subject",
    "pipeline": "Pipeline",
    "selectPipeline": "Pipelines",
    "allPipelines": "All pipelines",
    "pipelineName": "Pipeline Name",
    "message": "Message",
    "query": "Search Errors",
    "noResults": "No error history is currently available.",
    "noErrors": "No errors",
    "errorLogTitle": "Error History",
    "threshold": {
      "emptyState": {
        "title": "Create a new Threshold Alert",
        "description": "Monitor your pipeline ingress and egress behavior by creating alerts that trigger when matched to your criteria.",
        "moreInfo": "{ This is more information about Threshold Alerts. When there are multiple alert types in the future, this will be more information about alert options. }  Link to docs"
      },
      "columns": {
        "status": "Status",
        "title": "Title",
        "alertType": "Alert Type",
        "timePeriod": "Time Period",
        "active": "Active"
      },
      "title": "Pipeline Alerts ",
      "deliveryMethod": "Delivery Method",
      "deleteAlert": "Delete Alert",
      "deleteMessage": "Are you sure you want to delete this threshold alert?",
      "form": {
        "back": "all alerts",
        "createAnAlert": "Create Threshold Alert",
        "createSurgeAlert": "Create Surge Alert",
        "editAnAlert": "Edit Threshold Alert",
        "triggerOn": "Trigger an alert by adding a max z score and/or threshold for Pipeline ingress/egress ",
        "triggerOnInfo": "The z score is the count of standard deviations. Standard deviations are measured by  {more explanation}",
        "triggerOnZScore": "Trigger an alert by adding a z-score for Ingress/Egress (optional)",
        "triggerOnThreshold": "Alert on a threshold (optional)",
        "ingressThresholdZ": "Ingress z-score",
        "egressThresholdZ": "Egress z-score",
        "ingressThresholdBytes": "Ingress threshold",
        "egressThresholdBytes": "Egress threshold",
        "frequency": "Alert frequency",
        "recipients": "Recipient",
        "save": "Create Alert",
        "update": "Update Alert",
        "edit": "Edit Alert",
        "maxDailyNotifications": "Max daily notifications",
        "minutes": "minutes",
        "hours": "hours",
        "days": "days",
        "timeFrame": "Evaluate over time period ",
        "thresholdBytes": "{{type, capitalize}} threshold",
        "percentIncrease": "Percent above average ",
        "percentDecrease": "Percent below average ",
        "name": "Title",
        "alertType": "Threshold type",
        "alertOn": "Alert on",
        "description": "Description",
        "threshold": "Threshold",
        "percent": "Percent",
        "descriptionAbsolute": "Trigger an {{type}} alert when an absolute value for the set time frame is reached.",
        "descriptionRelative": "Trigger a relative {{type}} alert by setting a percentage above or below the time frame average.",
        "descriptionNoData": "Trigger an {{type}} alert when no data is present for the set time range.",
        "absolute": "Absolute",
        "relative": "Relative",
        "noData": "Absence"
      }
    },
    "nodeAlerts": {
      "title": "Deployed Node Alerts",
      "columns": {
        "status": "Status",
        "title": "Title",
        "alertType": "Alert Type",
        "eventType": "Event Type",
        "node": "Node",
        "deployed": "Deployed",
        "dimension": "Dimension"
      },
      "emptyState": {
        "description": "Get alerted on the state of a specific pipeline node.  To create a new alert, go to the pipeline view and click on the alerts tab of a pipeline node.",
        "createAlert": "Create Node Alerts in pipeline"
      }
    }
  },
  "nodeAlerts": {
    "maxAlerts": "You have reached the maximum number of alerts allowed per pipeline",
    "newAlert": "New Alert",
    "newSurgeAlert": "New Surge Alert",
    "noAlertsConfiguredTitle": "No Alerts Configured",
    "noAlertsConfiguredDesc": "Click \"New Alert\" button above to get started",
    "tray": {
      "title": "Alert Configured",
      "body": "This node has alerts configured."
    }
  },
  "pipelineNodeContextMenu": {
    "viewConfig": "View config",
    "editConfig": "Edit config",
    "tapEgress": "Tap egress",
    "tapPopoverTitle": "Tap egress not available",
    "tapPopoverContent": "<p>Only nodes that have been deployed can be tapped to save a sample to use in pipeline simulation.</p><a href=\"https://docs.mezmo.com/telemetry-pipelines/view-pipeline-data\" target=\"_blank\">Sampling and Simulation docs</a>",
    "simulate": "Simulate pipeline",
    "addProcessor": "Add processor",
    "addDestination": "Add destination",
    "spliceLeft": "Splice processor left",
    "spliceRight": "Splice processor right",
    "goToProfile": "View profiles",
    "clone": "Clone",
    "editParsers": "Edit parsers",
    "viewParsers": "View parsers",
    "tapDisabled": "Tapping in the UI is disabled",
    "tapLocallyVectorCmd": "Tap locally with this vector command",
    "tapWithPlayground": "Vector's Graphql playground",
    "localTapDocs": "How to configure for local tapping",
    "alert": "Alerts",
    "delete": "Delete"
  },
  "manage": {
    "edgePipelines": {
      "description": "The port range that will be allocated for sources across all pipelines in your on-premises deployment. These ports will be available to select when configuring a source, and will be exposed within your cluster to send data through your pipeline(s).",
      "servicePorts": "Service Ports",
      "startingPort": "Starting port",
      "endingPort": "Ending port"
    }
  },
  "deleteNodeModal": {
    "title": "Delete node",
    "message": "Are you sure you want to delete the <strong>{{ nodeName }}</strong> node? This action cannot be undone.",
    "messageNoName": "Are you sure you want to delete this node? This action cannot be undone.",
    "confirm": "Yes, delete"
  },
  "cloneNodeModal": {
    "title": "Clone Node",
    "description": "Duplicate this nodes and configuration to this pipeline or to another pipeline.",
    "cloneTo": "Clone this node to",
    "preserveConnection": "Preserve incoming connections to the cloned node",
    "nodeTitle": "Title",
    "nodeDescription": "Description",
    "currentPipeline": "Current pipeline",
    "currentProcessorGroup": "Current processor group"
  },
  "processorGroups": {
    "processorGroup": "Processor Group",
    "title": "Processor Groups",
    "createButton": "New processor group",
    "description": "A Processor Group is a collection of processors organized together for easy reuse across different pipelines.",
    "noResults": "There are no processor groups created yet.",
    "processorGroupInput": "Processor Group Input",
    "processorGroupDescription": "The input group source for a processor group",
    "latest": {
      "title": "Processor group outdated",
      "message": "Clicking the upgrade button will update this processor group to the latest version. If there are nodes in the currently used processor group that are no longer used in the latest version, their corresponding edge connections will be removed.",
      "warning": "This process is irreversible",
      "button": "Upgrade to latest processor group"
    },
    "navigate": {
      "message": "All changes to this processor group have been saved but in order to consume these changes in a pipeline you need to publish them.",
      "question": "Would you like to publish your changes at this time?"
    },
    "tray": {
      "body": "Click upgrade to view and upgrade to the latest processor group configuration"
    },
    "edit": "Edit processor group"
  },
  "sharedSources": {
    "title": "Shared Sources",
    "createButton": "New shared source",
    "description": "Share sources are sources you can reuse across your pipelines. Not all sources can be a created as a shared source at this time.",
    "noResults": "There are no shared sources created yet.",
    "cannotDeleteNode": "Node cannot be deleted.  Currently used in {{count}} pipeline(s)",
    "infoBox": {
      "message": "Shared sources are managed on the shared sources page",
      "link": "Manage Shared Sources"
    },
    "status": {
      "waiting": "Waiting for events to arrive",
      "percentCompleted": "{{ percent }}% complete",
      "completed": "Classification is complete"
    },
    "classifierNodeTrayTitle": "Classifying data",
    "classifierNodeTray": "Classifying incoming data is in-progress.",
    "manageSharesSource": "Manage Shared Sources",
    "usedInPipelines": "Pipelines this shared source is used in",
    "usedInPipelinesNoResults": "This shared source is not used in any pipelines.",
    "convert": {
      "title": "Convert to Shared Source",
      "description": "Share sources are sources you can reuse across all your pipelines.",
      "ok": "Convert",
      "convertButton": "Convert to Shared Source"
    }
  },
  "pipelineReplay": {
    "inProgressTitle": "Replay in progress",
    "inProgressDescription": "Both new incoming data and previously processed data is flowing from this source.",
    "finishedTitle": "Replay complete",
    "finishedDescription": "Only new incoming data is flowing from this source.",
    "percentCompleted": "{{ percent }}% complete"
  },
  "profiler": {
    "title": "Data Profiler",
    "dataProfilerList": "Data profiler list",
    "activeProcessors": "Applied Processors",
    "profilerCreated": "Profile created",
    "description": "The Data Profiler analyzes data and presents an overview of the most common message patterns, as well as the apps and hosts, contributing to the overall log volume.",
    "back": "shared sources",
    "inProgress": "Classification in progress",
    "runAnalysis": "Run Analysis",
    "rerunAnalysis": "Rerun Analysis",
    "resetProfile": "Reset profile",
    "stopAnalysis": "Stop Analysis",
    "noAnalysisData": "This shared source has not received enough data to generate a data profiling report.  Please rerun data analysis.",
    "noResults": "No Results",
    "logMetrics": "Log Metrics",
    "logMetricsByApp": "By App",
    "logMetricsByHost": "By Host",
    "logMetricsByLevel": "By Level",
    "logMetricsByLogType": "By Log Type",
    "manageProfiler": "Manage Profile",
    "processLogs": "Process Logs",
    "totalEvents": "Total Events",
    "eventTypes": "Event Types",
    "totalEventSize": "Total Event Size",
    "uniqueHosts": "Unique Hosts",
    "uniqueApps": "Unique Apps",
    "originalSize": "Original Size",
    "reducedSize": "Reduced Size Estimate",
    "applyProcessors": "Confirm Choices and Proceed",
    "applyProcessorsInstructionTitle": "Add Some Simple Processors Below",
    "applyProcessorsInstructionConfirm": "Apply processors to message templates below and see an estimate on how it can reduce log volume. We'll use default values to start-you can edit them later. Click the <strong>Apply Processors</strong> button at any time to create a pipeline with processors based on your selections. For a full list of available processors, refer to our <a href=\"https://docs.mezmo.com/telemetry-pipelines/supported-processors\" target=\"_blank\">product documentation</a>.",
    "applyProcessorsInstructionApply": "Apply processors to message templates below and see an estimate on how it can reduce log volume. We'll use default values to start-you can edit them later. Click the <strong>Confirm Choices and Proceed</strong> button at any time to create a pipeline with processors based on your selections. For a full list of available processors, refer to our <a href=\"https://docs.mezmo.com/telemetry-pipelines/supported-processors\" target=\"_blank\">product documentation</a>.",
    "reviewProcessorsInstructionTitle": "Review Processors",
    "reviewProcessorsInstruction": "The processors you have selected are listed below. You may return to make additional edits or proceed to unlock the full capabilities of your pipeline. Once unlocked, you can add or modify source data, destinations, and the processors you've just configured, as well as explore and incorporate additional functionalities from our comprehensive suite of powerful tools. Review the <a href=\"https://docs.mezmo.com/telemetry-pipelines/supported-processors\" target=\"_blank\"documentation</a> to fully understand the extensive capabilities of Mezmo's products.",
    "filterApp": "Filter by App",
    "clickToRemove": "Click here to remove",
    "goToPipeline": "Go to pipeline",
    "goToProcessorGroup": "Go to processor group",
    "messageTemplates": "Message Templates",
    "all": "All",
    "remainingEvents": "Remaining Events: {{count}}",
    "expirationDate": "Expires: {{date}}",
    "processorsApplied": "Processors Applied",
    "refreshesAutomatically": "Refreshes automatically",
    "clickToPause": "click to pause",
    "clickToResume": "click to resume",
    "onlyApplied": "Only show applied",
    "list": {
      "title": "Data Profiles",
      "description": "List of data profiler runs sorted by data profiler processor node.",
      "noResults": "There are either no pipelines with a data profiler node or no data profiler runs are in progress.",
      "noResultsFiltered": "No results found. Adjust the filters to see more results.",
      "inProgress": "In progress",
      "goToPipeline": "Go to pipeline",
      "searchByTitle": "Search by processor title",
      "byNode": "Data profiler processor",
      "pipelines": "Pipelines",
      "viewProfile": "View profile"
    },
    "sampleMessages": {
      "title": "Matching log samples",
      "noResults": "No samples found"
    },
    "templates": {
      "apps": "Apps",
      "template": "Template",
      "count": "Total Lines",
      "totalSize": "Total Size",
      "value": "Value"
    },
    "fieldSummaries": {
      "title": "Field Summaries",
      "apps": "Apps",
      "field": "Field",
      "cardinality": "Unique Values",
      "count": "Total Lines",
      "logSize": "Total Size",
      "fieldSize": "Field Size",
      "value": "Value"
    },
    "costSavings": {
      "label": "Estimated Cost Saved",
      "tooltip": "Pricing estimate is based on current throughput and Datadog's Standard Pricing Plan. Chat with us today to get a more in depth look into how Mezmo can help save on observability costs!"
    },
    "waitingForEvents": {
      "title": "Waiting for events",
      "description": "We're waiting for events to arrive. Typically, this takes just a few minutes.",
      "tooLong": "This appears to be taking longer than expected.",
      "reviewInstructions": "Review the instructions below and double check your setup.",
      "reviewInstructionsLink": "Click here to view the instructions",
      "reviewInstructionsLink2": "and double check your setup.",
      "accessKeyMessage": "If you saved your access key from when you created your pipeline paste it here. If you did not, click the button below to create a new one. The access key will automatically be added to the instructions below for easy copy/paste.",
      "accessKeyButton": "Create new access key",
      "addDemoSourceTitle": "Not ready to send us your data?",
      "addDemoSourceButton": "Click here to add our demo data source",
      "addDemoSourceButton2": "and explore how your pipeline works.",
      "dataProfilerLongDescription": "The Data Profiler analyzes Source data and presents an overview of the most common message patterns, as well as the apps and hosts, contributing to the overall log volume. You can then choose common actions to take on the data from the Profiler page such as Filter or Sample and immediately see the estimated impact it will have on your data volume.",
      "sendAlertTitle": "Don't want to wait here?",
      "sendAlertMessage1": "We'll send you an alert as soon as your profile is ready to view!",
      "sendAlertMessage2": "While you are waiting, we suggest checking out our <a href=\"https://docs.mezmo.com/telemetry-pipelines/getting-started\" target=\"_blank\">getting started guide</a>.",
      "addDemoSourceToPipelineTitle": "Updating your pipeline",
      "addDemoSourceToPipelineDescription": "We're updating your pipeline to include the demo data source. This will take just a moment."
    }
  },
  "edgeInstance": "Edge Instance",
  "allEdgeInstances": "All edge instances",
  "pipelineDeployedSuccessfully": "Pipeline was deployed successfully",
  "processorGroupPublishedSuccessfully": "Processor group was published successfully",
  "pipelineDeployedFailed": "Pipeline failed to deploy.",
  "processorGroupPublishedFailed": "Processor group failed to publish",
  "createFromPipeline": {
    "message": "Select processors to add to a new group, then click \"Create Processor Group.\"",
    "button": "Create processor group"
  },
  "ai": {
    "patternMatcher": {
      "title": "AI Pattern Matcher",
      "description": "Use the power of AI to generate the best pattern matcher for the provided sample of log lines.",
      "warning": "By using this service you agree to allow Mezmo to send the provided log line samples to a 3rd party service.  Please scrub any sensitive or user identifying data from your provided samples.",
      "provideLogsTitle": "Sample log lines",
      "provideLogsDescription": "Provide up to {{ count }} sample log lines, 1 per line",
      "button": "Find Patterns",
      "resultMessage": "{{ count }} {{ expressionType }} patterns were found from the supplied samples.",
      "selectPattern": "Select pattern"
    }
  },
  "eventMetrics": {
    "title": "Event Metrics",
    "subTitle": "View historic event volume & trends per App, Host, Level & Label in a selected time window",
    "volumeBy": "Event Volume By {{ type }}",
    "fields": {
      "title": "Select items to graph",
      "selected": "{{ count }} of {{ total }} selected",
      "select": "Select",
      "all": "All",
      "none": "None",
      "sort": "Sort",
      "alpha": "A-Z",
      "size": "Size"
    },
    "gatherMetrics": "Gathering event metrics. Please wait...",
    "noData1": "There are no event metrics data for the selected time period.",
    "noData2": "We are either still gathering data or you can adjust your time period to try again",
    "errorMsg": "There was an issue gathering event metrics.",
    "percentChange": "Percent Change vs Last Period",
    "hoverMsg": "Hover over the chart to see a breakdown at each time bucket",
    "emptyState": {
      "title": "Missing Data Profiler Processor",
      "description": "Event metrics requires a Data Profiler processor to be present and deployed in this pipeline in order to start gathering event metrics."
    }
  },
  "export": {
    "export": "Export",
    "popover": {
      "title": "Unable to export",
      "content": "This pipeline contains {{nodes}} which is currently not supported by the export",
      "content_plural": "This pipeline contains {{nodes}} which are currently not supported by the export",
      "titleEdge": "Unsupported pipeline type",
      "contentEdge": "Exporting Edge pipelines is currently not supported"
    }
  }
}
